import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import ComponentTable from './ComponentTable';
import SignalPinTable from './signalPinTable';
import designConstructor from '@/services/helper/designConstructor';
import { PRE_LAYOUT } from '../../../constants/designVendor';
import LayoutData from '@/services/data/LayoutData';
import { selectLayer, selectChange } from '../../LayoutExplorer/store/Andes_v2/actionCreators';
import PowerNetsTable from './PowerNetsTable';
import DesignInfo from '@/services/Andes_v2/pcbInfo';
import { refreshPCB } from '../store/project/action';
import { isEndToEndChildrenChannel } from '@/services/Andes_v2';
import { getSelectedDesignIDs } from '@/services/helper/dataProcess';
import canvas from '@/services/LayoutCanvas';
import MultiModelContent from './multiModelContent';
import { updateChannelContent, updateSimulationSolverStatus } from '../store/channel/action';
import { getSetupComponentInfo } from '@/services/Andes_v2/channel';
import _ from 'lodash';
import { SERDES_TYPES } from '../../../services/PCBHelper';
import AdditionalNets from '@/components/AdditionalNets';
import { CPHY } from '../../../services/PCBHelper/constants';
import { HSPICE } from '../../../services/Andes_v2/simulation';
import { ANDES_V2 } from '../../../constants/pageType';
import HspiceSimulation from './HspiceSimulation';
import "./index.css";

class ChannelSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      PCBNetsObj: {},
      compsInfo: {},
      advanced: false,
      needChangeComp: "",
      isUpdateComponentModel: false
    }
  }

  componentDidMount = () => {
    this.getPcbNets({});
  }

  componentDidUpdate = (prevProps) => {
    const { verificationId, simulationSolver, simulationSolverStatus } = this.props;
    if ((verificationId && verificationId !== prevProps.verificationId)) {
      this.setState({ advanced: false })
    }

    if (simulationSolver === HSPICE && simulationSolverStatus) {
      const hspiceSimulationElement = document.getElementById("andes-v2-hspice-simulation");
      // If the anchor corresponding to ID exists, jump to the anchor
      if (hspiceSimulationElement) { hspiceSimulationElement.scrollIntoView() }
      this.props._updateSimulationSolverStatus(false);
    }
    this.getPcbNets(prevProps);
  }

  changeAdvanced = () => {
    this.setState({
      advanced: !this.state.advanced
    })
  }

  displayToLayout = (compNames, nets, pinsObj) => {
    const { channelDesignId, viewList } = this.props;
    const design = designConstructor.getDesign(channelDesignId);
    if (viewList && viewList.length > 1 && design.vendor !== PRE_LAYOUT) {
      this.viewToLayout(compNames, nets, pinsObj);
    }
  }

  viewToLayout = (compNames = [], nets = [], pinsObj = {}) => {
    const { channelDesignId } = this.props;
    const layout = canvas.getLayout(channelDesignId);
    let layers = layout.findCurrentLayer(compNames);
    layers = [...new Set(layers)];
    this.props._selectLayer(layers, channelDesignId);
    this.props._selectChange({ nets: [...nets], comps: [...compNames], pinsObj }, channelDesignId);
  }

  checkLoadPCB = ({ PCBNetsObj, channelDesignId, prevProps, refreshDesignId }) => {
    if (!PCBNetsObj[channelDesignId]
      || !PCBNetsObj[channelDesignId].length
      || prevProps.channelDesignId !== channelDesignId
      || (refreshDesignId && refreshDesignId === channelDesignId)
    ) {
      return true;
    }
  }

  getPcbNets = (prevProps) => {
    //get pcb info
    const { channelDesignId, pcbComponentsNets = [], refreshDesignId, components, signals } = this.props;
    const { PCBNetsObj } = this.state;

    const compNames = components ? components.filter(item => SERDES_TYPES.includes(item.type)).map(item => item.name) : [];
    const prevCompNames = prevProps.components ? prevProps.components.filter(item => SERDES_TYPES.includes(item.type)).map(item => item.name) : [];

    if (channelDesignId && this.checkLoadPCB({ PCBNetsObj, channelDesignId, prevProps, refreshDesignId }) && pcbComponentsNets.includes(channelDesignId)) {
      const design = designConstructor.getDesign(channelDesignId);
      if (design && design.vendor === PRE_LAYOUT) {
        return;
      }
      const info = DesignInfo.getPCBInfo(channelDesignId);
      const netsList = info && info.netsList ? info.netsList : [];
      let _PCBNetsObj = PCBNetsObj || {};
      _PCBNetsObj[channelDesignId] = netsList;
      //get components pins nets
      if (refreshDesignId && refreshDesignId === channelDesignId) {
        LayoutData.setCompPinsNets(channelDesignId);
      }
      LayoutData.getCompPinsNets(channelDesignId);

      this.setState({
        PCBNetsObj: _PCBNetsObj,
        compsInfo: getSetupComponentInfo({ channelDesignId, components, signals })
      }, () => {
        this.signalChild && this.signalChild.getPCBNets();
      })
    } else if (!_.isEqual(compNames, prevCompNames)) {
      const design = designConstructor.getDesign(channelDesignId);
      if (design && design.vendor !== PRE_LAYOUT) {
        this.setState({
          compsInfo: getSetupComponentInfo({ channelDesignId, components, signals })
        })
      }
    }

    if (refreshDesignId && refreshDesignId !== prevProps.refreshDesignId) {
      this.props._refreshPCB(null)
    }
  }

  scrollToAnchor = (compName) => {
    const anchorElement = document.getElementById(compName ? `${compName}-multi-content-setup-dialog` : "channel-builder-multi-content-setup-dialog");
    // If the anchor corresponding to ID exists, jump to the anchor
    if (anchorElement) { anchorElement.scrollIntoView(); }
  }

  saveAdditionalNets = (nets, option) => {
    this.props._updateChannelContent({ additionalNets: nets, additionalNetsOption: option });
  }

  changeNeedChangeComp = (comp, otherComp) => {
    let needChangeComp = comp;
    if (comp) {
      const compNames = this.multiModelRef.getNewCompName();
      needChangeComp = compNames.includes(comp) ? comp : compNames.includes(otherComp) ? otherComp : "";
    }

    this.setState({
      needChangeComp
    }, () => {
      if (needChangeComp) {
        this.scrollToAnchor(needChangeComp);
        setTimeout(() => {
          this.changeNeedChangeComp("");
        }, 5000);
      }
    })
  }

  updateComponentModel = () => {
    this.setState({
      isUpdateComponentModel: !this.state.isUpdateComponentModel
    })
  }

  render() {
    const { components, signals, serdesType, libraryStatus, selectedSignals, isEndToEndChildren,
      powerNets, endToEndId, channelDesignId, channelLoading, channelId, viewList, selectedDesignIDs,
      additionalNets, simulationSolver, comp_merges, comp_copies, powerNetsTableLoading } = this.props;
    const { PCBNetsObj, compsInfo, advanced, needChangeComp, isUpdateComponentModel } = this.state;
    const design = designConstructor.getDesign(channelDesignId);
    const pcbNetsList = PCBNetsObj[channelDesignId] || [];
    return (
      <Fragment>
        <div className='andes-v2-content-setting pcb-channel-main' id="andes-v2-content-setting pcb-channel-main-id">
          <Spin spinning={channelLoading}>
            <ComponentTable
              components={components}
              signals={signals}
              selectedDesignIDs={selectedDesignIDs}
              powerNets={powerNets}
              channelDesignId={channelDesignId}
              viewList={viewList}
              channelId={channelId}
              libraryStatus={libraryStatus}
              pcbNetsList={pcbNetsList}
              serdesType={serdesType}
              scrollToAnchor={this.scrollToAnchor}
              displayToLayout={this.displayToLayout}
              comp_merges={comp_merges}
              comp_copies={comp_copies}
              needChangeComp={needChangeComp}
              updateComponentModel={this.updateComponentModel}
              designType={design ? design.type : null}
              designVendor={design ? design.vendor : null}
            />
            <div className='space-10'>
              <SignalPinTable
                onRef={(ref) => this.signalChild = ref}
                components={components}
                selectedDesignIDs={selectedDesignIDs}
                endToEndId={endToEndId}
                isEndToEndChildren={isEndToEndChildren}
                displayToLayout={this.displayToLayout}
                channelDesignId={channelDesignId}
                signals={signals}
                designVendor={design ? design.vendor : null}
                viewList={viewList}
                serdesType={serdesType}
                channelId={channelId}
                pcbNetsList={pcbNetsList}
                selectedSignals={selectedSignals}
                compsInfo={compsInfo}
                comp_merges={comp_merges}
                comp_copies={comp_copies}
                powerNetsTableLoading={powerNetsTableLoading}
              />
            </div>
            {design && design.vendor !== PRE_LAYOUT ? <div className='space-10'>
              <PowerNetsTable
                powerNets={powerNets}
                displayToLayout={this.displayToLayout}
                channelDesignId={channelDesignId}
                pcbNetsList={pcbNetsList}
                signals={signals}
                serdesType={serdesType}
                powerNetsTableLoading={powerNetsTableLoading}
              />
            </div> : null}
            {design && design.vendor !== PRE_LAYOUT ? <Fragment>
              <div className='space-10'>
                <div className='channel-setup-border'>
                  <div className='channel-advanced-title'>
                    {advanced ? <DownOutlined onClick={this.changeAdvanced} /> : <RightOutlined onClick={this.changeAdvanced} />}
                    <span onClick={this.changeAdvanced}>Advanced</span>
                  </div>
                  {advanced ? <div className='space-10'>
                    <AdditionalNets
                      designId={channelDesignId}
                      additionalNets={additionalNets}
                      saveAdditionalNets={this.saveAdditionalNets}
                      matchWidth={false}
                      product={ANDES_V2}
                      signals={signals}
                    />
                  </div> : null}
                </div>
              </div>
            </Fragment> : null}
            <MultiModelContent
              onRef={ref => this.multiModelRef = ref}
              design={design}
              needChangeComp={needChangeComp}
            />
            {serdesType === CPHY && simulationSolver === HSPICE ? <div className='space-10'>
              <HspiceSimulation
                scrollToAnchor={this.scrollToAnchor}
                changeNeedChangeComp={this.changeNeedChangeComp}
                updateComponentModel={this.updateComponentModel}
                isUpdateComponentModel={isUpdateComponentModel}
              />
            </div> : null}
          </Spin>
        </div>
      </Fragment>
    );
  }
}

const mapState = (state) => {
  const {
    channel: {
      channelInfo: { content = {}, designId, type, endToEndId, verificationId },
      channelLoading, channelId, simulationSolverStatus,
      powerNetsTableLoading
    },
    project: { viewList, layout, pcbComponentsNets, refreshDesignId, selectedKeys },
    library: { libraryStatus },
    explorer: { selections }
  } = state.AndesV2Reducer;
  const {
    components = [],
    signals = [],
    powerNets = [],
    selectedSignals = [],
    additionalNets = [],
    simulationSolver,
    comp_merges = [],
    comp_copies = []
  } = content;
  const layers = selections[designId] ? (selections[designId].layers || []) : [];
  return {
    components,
    signals,
    powerNets,
    channelDesignId: designId,
    selectedDesignIDs: getSelectedDesignIDs(selectedKeys),
    viewList,
    layers,
    channelId,
    layout,
    pcbComponentsNets,
    serdesType: type,
    refreshDesignId,
    selectedSignals,
    channelLoading,
    libraryStatus,
    endToEndId,
    isEndToEndChildren: isEndToEndChildrenChannel({ endToEndId }) ? true : false,
    verificationId,
    additionalNets,
    simulationSolver,
    simulationSolverStatus,
    comp_merges,
    comp_copies,
    powerNetsTableLoading
  }
}

const mapDispatch = (dispatch) => ({
  _selectLayer(layers, designID) {
    dispatch(selectLayer(layers, designID));
  },
  _selectChange(obj = {}, designID) {
    dispatch(selectChange(obj, designID))
  },
  _refreshPCB(refreshDesignId) {
    dispatch(refreshPCB(refreshDesignId))
  },
  _updateChannelContent(content) {
    dispatch(updateChannelContent(content))
  },
  _updateSimulationSolverStatus(status) {
    dispatch(updateSimulationSolverStatus(status))
  }
})

export default connect(mapState, mapDispatch)(ChannelSetup);